const Felonies = (props) => {
    return (
        <div className="lyrics eggshell">
            <h2>Felonies</h2>
            <h4>Jennifer Michael Hecht</h4>
            <p>Loneliness is criminal, but the law<br/>
            spits and looks the other way.<br/>
            Every night, hooligans break into my apartment,<br/>
            kick the phone until it rings, and disappear<br/>
            before I can arrive; shaken, unwell, and in<br/>
            disrepair. How else can I explain all of those bells?<br/>
            <br/>
            It couldn’t possibly be you, out there<br/>
            in the night’s phone booth, calling and falling away.<br/>
            The world is full of such wonderful alibis. You and I<br/>
            are as wise as only silent, tired things can be,<br/>
            no more assailed by lust or filibust or the turning<br/>
            of your interminable key.<br/>
            <br/>
            I insist: We are past all harm. How else<br/>
            can I explain, through such adversity,<br/>
            the persistence of all our wild virginities?<br/>
            Everything is air-tight. All of my lies<br/>
            are true. I answer the phone in the middle<br/>
            of the night: it is you again, it is always you.<br/>
            <br/>
            <small>Reprinted with permission.<br/>&copy;Jennifer Michael Hecht. All Rights Reserved</small>
            </p>
        </div>
    )
}
export default Felonies;